import UserSettingsConfiguration from "modules/user_settings/UserSettingsConfiguration";

import {EmailPreviewService, EmailPreviewServiceName} from "modules/user_settings/service/EmailPreviewService";
import {
    UserSettingsController
} from "modules/user_settings/component/email-settings/user_settings_selector/user-settings-controller";
import {EmailToneRow} from "modules/user_settings/component/email-settings/email-tone-row/email-tone-row";
import {
    EmailSettingsPreview
} from "modules/user_settings/component/email-settings/email-settings-preview/email-settings-preview";
import {
    OpportunitySelector
} from "modules/user_settings/component/email-settings/opportunity-selector/opportunity-selector";
import {
    EmailLengthSelector
} from "modules/user_settings/component/email-settings/email-length-selector/email-length-selector";
import {LeftSide} from "modules/user_settings/component/email-settings/left-side/left-side";
import {RightSide} from "modules/user_settings/component/email-settings/right-side/right-side";
import {UserSettingsService, UserSettingsServiceName} from "modules/user_settings/service/UserSettingsService";
import {
    SmsSettingsController
} from "modules/user_settings/component/sms-settings/sms_settings_selector/sms-settings-controller";
import {SmsLeftSide} from "modules/user_settings/component/sms-settings/left-side/sms-left-side";
import {SmsRightSide} from "modules/user_settings/component/sms-settings/right-side/sms-right-side";
import {
    SmsSettingsPreview
} from "modules/user_settings/component/sms-settings/sms-settings-preview/sms-settings-preview";

UserSettingsConfiguration
    .createNewModule()
    .controller("UsersSettingsController", UserSettingsController.instance)
    .controller("SmsSettingsController", SmsSettingsController.instance)
    .component("emailToneRow", EmailToneRow.instance)
    .component("emailSettingsPreview", EmailSettingsPreview.instance)
    .component("opportunitySelector", OpportunitySelector.instance)
    .component("emailLengthSelector", EmailLengthSelector.instance)
    .component("leftSide", LeftSide.instance)
    .component("smsLeftSide", SmsLeftSide.instance)
    .component("smsRightSide", SmsRightSide.instance)
    .component("smsSettingsPreview", SmsSettingsPreview.instance)
    .component("rightSide", RightSide.instance)
    .service(UserSettingsServiceName, UserSettingsService.instance)
    .service(EmailPreviewServiceName, EmailPreviewService.instance);

